import { Column, ColumnSubType } from '@scale/compass-shared/types';
import { CdsUploadRequiredColumns } from '@scale/genai-compass-shared/cards/cds_upload';

export const getTaskIdColumn = (retrievedOutput: any) => {
  const columns = retrievedOutput?.response?.schema || [];

  // First try to find by subtype (more reliable)
  const columnBySubtype = columns.find((col: Column) => col.subType === ColumnSubType.TASK_ID);

  if (columnBySubtype) {
    return columnBySubtype;
  }

  // Fallback to header name matching
  return columns.find((col: Column) => col.header === CdsUploadRequiredColumns.TASK);
};

export const getGoogleDriveUrlColumn = (retrievedOutput: any) => {
  const columns = retrievedOutput?.response?.schema || [];

  // For now, we only look for Google Drive URL by header
  // as there's no specific column subtype for it
  return columns.find((col: Column) => col.header === CdsUploadRequiredColumns.GOOGLE_DRIVE_URL);
};

export const getImageUrlColumn = (retrievedOutput: any) => {
  const columns = retrievedOutput?.response?.schema || [];

  // For now, we only look for Image URL by header
  // as there's no specific column subtype for it
  return columns.find((col: Column) => col.header === CdsUploadRequiredColumns.IMAGE_URL);
};
